const CLOSED_TRANSLATE_Y = '12px';
const OPEN_TRANSLATE_DELAY = '0.1s';
const CLOSE_TRANSLATE_DELAY = '0s';

const getAccordionBodyWrapper = accordionElement =>
    accordionElement?.querySelector('[js-accordion-body-wrapper]');

const getAccordionBody = accordionElement =>
    accordionElement
        ?.querySelector('[js-accordion-body-wrapper]')
        ?.querySelector('[js-accordion-body]');

const setClosedState = accordionElement => {
    const bodyWrapper = getAccordionBodyWrapper(accordionElement);
    const body = getAccordionBody(accordionElement);
    if (!bodyWrapper || !body) return;

    bodyWrapper.style.height = '0px';
    bodyWrapper.style.opacity = '0';
    body.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
    body.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
    body.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
};

const setOpenedState = accordionElement => {
    const bodyWrapper = getAccordionBodyWrapper(accordionElement);
    const body = getAccordionBody(accordionElement);
    if (!bodyWrapper || !body) return;

    bodyWrapper.style.height = 'auto';
    bodyWrapper.style.opacity = '1';
    body.style.transitionDelay = OPEN_TRANSLATE_DELAY;
    body.style.transform = 'translateY(0)';
    body.style.translate = `0 0`;
};

const animateOpen = accordionElement => {
    const bodyWrapper = getAccordionBodyWrapper(accordionElement);
    const body = getAccordionBody(accordionElement);
    if (!bodyWrapper || !body) return;

    const targetHeight = body.scrollHeight;

    bodyWrapper.style.height = '0px';
    bodyWrapper.style.opacity = '0';
    body.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
    body.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
    body.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
    void bodyWrapper.offsetHeight;

    bodyWrapper.style.height = `${targetHeight}px`;
    bodyWrapper.style.opacity = '1';
    body.style.transitionDelay = OPEN_TRANSLATE_DELAY;
    body.style.transform = 'translateY(0)';
    body.style.translate = `0 0`;

    const handleTransitionEnd = event => {
        if (event.propertyName !== 'height') return;

        if (accordionElement.classList.contains('-active')) {
            bodyWrapper.style.height = 'auto';
        }

        bodyWrapper.removeEventListener('transitionend', handleTransitionEnd);
    };

    bodyWrapper.addEventListener('transitionend', handleTransitionEnd);
};

const animateClose = accordionElement => {
    const bodyWrapper = getAccordionBodyWrapper(accordionElement);
    const body = getAccordionBody(accordionElement);
    if (!bodyWrapper || !body) return;

    const startHeight = body.scrollHeight;

    bodyWrapper.style.height = `${startHeight}px`;
    bodyWrapper.style.opacity = '1';
    body.style.transitionDelay = OPEN_TRANSLATE_DELAY;
    body.style.transform = 'translateY(0)';
    body.style.translate = `0 0`;
    void bodyWrapper.offsetHeight;

    bodyWrapper.style.height = '0px';
    bodyWrapper.style.opacity = '0';
    body.style.transitionDelay = CLOSE_TRANSLATE_DELAY;
    body.style.transform = `translateY(${CLOSED_TRANSLATE_Y})`;
    body.style.translate = `0 ${CLOSED_TRANSLATE_Y}`;
};

const syncAccordionContainerState = container => {
    container
        .querySelectorAll('[js-accordion-element]')
        .forEach(accordionElement => {
            const bodyWrapper = getAccordionBodyWrapper(accordionElement);
            const body = getAccordionBody(accordionElement);
            if (!bodyWrapper || !body) return;

            if (accordionElement.classList.contains('-active')) {
                setOpenedState(accordionElement);
                return;
            }

            setClosedState(accordionElement);
        });
};

export const syncAccordionState = root => {
    if (!root) return;

    if (root.matches?.('[js-accordion-elements]')) {
        syncAccordionContainerState(root);
    }

    root.querySelectorAll?.('[js-accordion-elements]').forEach(container => {
        syncAccordionContainerState(container);
    });
};

const checkboxMore = () => {
    window.addEventListener('click', e => {
        const toggle = e.target.closest('[js-checkbox-more-toggle]');
        if (!toggle) return;

        const root = toggle.closest('[js-checkbox-more]');
        if (!root) return;

        const isOpen = root.classList.toggle('-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
};

export const accordion = () => {
    syncAccordionState(document);
    checkboxMore();

    window.addEventListener('click', e => {
        if (e.target.closest('[js-tippy]')) return;
        if (!e.target.closest('[js-accordion-button]')) return;

        const accordionElement = e.target.closest('[js-accordion-element]');
        const isActive = accordionElement.classList.contains('-active');
        const parent = e.target.closest('[js-accordion-elements]');
        const isAllOpenedPossible =
            parent?.getAttribute('js-all-opened') != null;

        if (parent && !isAllOpenedPossible) {
            parent.querySelectorAll('[js-accordion-element]').forEach(el => {
                if (el === accordionElement) return;
                if (!el.classList.contains('-active')) return;

                el.classList.remove('-active');
                animateClose(el);
            });
        }

        if (!isActive) {
            accordionElement.classList.add('-active');
            animateOpen(accordionElement);
        } else {
            accordionElement.classList.remove('-active');
            animateClose(accordionElement);
        }

        window.dispatchEvent(
            new CustomEvent('accordion:change', {
                detail: {
                    opened: !isActive,
                    element: accordionElement,
                },
            })
        );
    });
};
